module.exports = __webpack_public_path__ + "static/media/iran7.1d8b90b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/panoramas/iran7.jpg
// module id = 260
// module chunks = 0